import React from 'react';
import { IconTimeLight } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface SpecialTimeProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const SpecialTime: React.FC<React.PropsWithChildren<SpecialTimeProps>> = ({ days, hours, minutes, seconds }) => {
  const renderTime = () => {
    let text = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
    if (days >= 1) {
      text = `${days}일`;
    }
    return <Time className={Typography.BODY_13_BOLD}>{text}</Time>;
  };
  return (
    <Wrap>
      <IconTimeLight size={20} color={'gray300'} />
      <Text className={Typography.BODY_13_MEDIUM}>특가 남은 시간</Text>
      {renderTime()}
    </Wrap>
  );
};

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  background-color: ${vars.v3Color.gray950};
`;

const Text = styled.p`
  margin: 0 6px 0 5px;
  color: ${vars.v3Color.gray400};
`;

const Time = styled.p`
  color: ${vars.v3Color.staticWhite};
`;
